import React, { CSSProperties } from 'react';
import HanabiLogoLoading from './HanabiLogoLoader';
import styles from './LoadingIndicator.module.scss';
import { DEFAULT_LOGO_LOADER_SIZE_PX } from 'src/constants/loader';

export interface LoadingIndicatorProps {
  style?: CSSProperties;
  showLogo?: boolean;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  style,
  showLogo = true,
}) => (
  <div
    className={styles['loading-container']}
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: style?.width ?? '100%',
      height: style?.height ?? '100%',
      background: 'transparent',
      ...style,
    }}
  >
    <div
      className={styles.logo}
      style={{
        width: style?.width ?? DEFAULT_LOGO_LOADER_SIZE_PX,
        height: style?.height ?? DEFAULT_LOGO_LOADER_SIZE_PX,
      }}
    >
      {showLogo && <HanabiLogoLoading />}
    </div>
  </div>
);

export default LoadingIndicator;
